<template>
  <div v-if="loadingEnd">
    <ul class="reocrd-list" v-if="orderList.length">
      <li class="record-list-item" v-for="(item, index) in orderList" :key="item.orderId" @click="jumpDetail(item.tradeId)">
        <div class="list-item-head">
          <p class="date">{{ item.createTime }}</p>
          <p :class="['status', { success: item.statusCode === 'FINISH' }]">
            <span>{{ item.statusName }}</span>
          </p> 
        </div>
        <div class="list-item-main">
          <img :src="handleImgHead(item.picUrls)" alt="" class="product-icon"> 
          <div class="product-info">
            <div class="first-line">
              <span class="product-title"><span>{{ item.productName + item.skuName }}</span></span>
              <span class="product-price"><span>￥{{ (item.salePrice * 1).toFixed(2) }}</span></span> 
            </div>
            <div>
              <span class="product-value"><span>{{ item.salePrice }}元</span></span> 
            </div>
            <div class="right">
              <p class="total-price"><span>总额：￥{{ (item.dealPrice * 1).toFixed(2) }}</span></p>
            </div>
          </div>
        </div>
        <div class="list-item-bottom" v-if="item.statusCode === 'TO_BE_PAY'" v-show="!disabledObj[index]">
          <button @click.stop="closeOrder(index)">取消订单</button>
          <button class="active" @click.stop="repay(item.orderNo)">重新支付</button>
        </div> 
        <!-- <div class="RLI-left">
          <p class="RLI-left-date">{{ item.createTime }}</p>
          <div class="RLI-left-product">
            <img :src="handleImgHead(item.picUrls)" alt="" class="product-icon">
            <div>
              <p class="product-title">{{ item.productName + item.skuName }}</p>
              <p class="product-value">{{ item.salePrice }}元</p>
            </div>
          </div>
        </div>
        <div class="RLI-right">
          <p :class="['RLI-right-status', { success: item.statusCode === 'FINISH' }]">
            <span>{{ item.statusName }}</span>
           </p>
          <p class="RLI-right-price">￥{{ (item.salePrice * 1).toFixed(2) }}</p>
          <p class="RLI-right-total">总额：￥{{ (item.dealPrice * 1).toFixed(2) }}</p>
        </div>
        <div class="RLI-bottom" v-if="item.statusCode === 'TO_BE_PAY'" v-show="!disabledObj[index]">
          <button @click.stop="closeOrder(index)">取消订单</button>
          <button class="active" @click.stop="repay(item.orderNo)">重新支付</button>
        </div> -->
      </li>

    </ul>
    <div class="no-record" v-else>
      <img src="../assets/img/no-record.png" alt="" class="no-record-icon">
      <p>暂无充值记录</p>
    </div>
  </div>
</template>

<script>
  import Api from '../service/api'
  import Store from '../utils/store'
  export default {
    data () {
      return {
        orderList: [],
        loadingEnd: false,
        disabledObj: {},
        offset: 0,
        pageSize: 20
      }
    },
    mounted () {
      this.getOrderList()
      this.init()
    },
    methods: {
      toTop () {
        setTimeout(() => {
          document.body.scrollTop = document.documentElement.scrollTop = 0
        }, 200)
      },
      init () {
        window.addEventListener('scroll', this.throttleFn(this.handleScroll))
        this.toTop()
      },
      handleScroll () {
        const windowHeight = document.documentElement.clientHeight || document.body.clientHeight
        const scrollTop = document.documentElement.scrollTop || document.body.scrollTop
        const scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight
        // 滚动到底部的条件
        if ((windowHeight + scrollTop) > (scrollHeight - 200)) {
          // console.log('请求到底了')
          this.offset += this.pageSize
          this.getOrderList()
        }
      },
      // 节流函数
      throttleFn (fn, delay=200) {
        let timer = null
        return function () {
          let args = arguments
          if (!timer) {
            timer = setTimeout(() => {
              fn.apply(this, args)
              timer = null
            }, delay)
          }
        }
      },
      // 防抖
      debounceFn (fn, delay=200) {
        let timer = null
        return function () {
          let args = arguments
          if (timer) {
            clearTimeout(timer)
          }
          timer = setTimeout(() => {
            fn.apply(this, args)
          }, delay)
        }
      },
      handleImgHead (url) {
        return Api.imgHeadUrl + url
      },
      getOrderList () {
        if (this.isLoadMore) return
        this.isLoadMore = true
        this.$http.getOrderList({
          authToken: Store.userInfo.token, 
          loginUserId: Store.userInfo.userId, 
          // orderTarget: '', 
          productType: 'ALL', 
          offset: this.offset,
          pageSize: this.pageSize
        }).then(({data}) => {
          if (data.success) {
            this.orderList =  [...this.orderList, ...data.datas ]
            // this.orderList = data.datas
            // 停止加载的条件
            this.isLoadMore = (data.datas.length < this.pageSize)
          }
        }).finally(() => {
          this.loadingEnd = true
        })
      },
      // 重新支付
      repay (orderNo) {
        const url = location.origin + location.pathname
        this.$http.secondPay({
          authToken: Store.userInfo.token,
          orderNo,
          payReturnUrl: url + '?state=success',
          unpayReturnUrl: url + '?state=fail',
        }).then(({data}) => {
          if (data.success) {
            window.location.href = data.datas.payStr
          } else {
            this.$tip('数据异常，请稍后重试')
          }
        })
      },
      // 取消订单
      closeOrder (index) {
        const item = this.orderList[index]
        if (this.disabledObj[index]) return
        const orderNo = item.orderNo
        this.$http.closeOrder({
          authToken: Store.userInfo.token, 
          orderNo
        }).then(({data}) => {
          if (data.success) {
            this.$set(this.disabledObj, index, true)
            this.$tip('订单取消成功')
          } else if (data.errorCode === '600') { // 未登录
            this.$login.show()
          } else {
            this.$tip('数据异常，请稍后重试')
          }
        })
      },
      // 订单详情
      jumpDetail (tradeId) {
        this.$router.push({path: '/detail', query: { tradeId }})
      }
    }
  }
</script>

<style lang="scss" scoped>
.record-list-item {
  position: relative;
  width: 1042px;
  height: 473px;
  border-radius: 12px;
  background-color: #fff;
  margin: 0 auto;
  margin-top: 20px;
  // display: flex;
  // justify-content: space-between;
  padding: 0 36px;
  .list-item-head {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 33px;
    .date {
      // margin-top: 40px;
      font-size: 30px;
      line-height: 30px;
      color: #666;
      text-indent: 53px;
      position: relative;
      &::before {
        content: '';
        width: 36px;
        height: 33px;
        background: url('../assets/img/record-date-icon.png') 0 0 / 100% 100% no-repeat;
        position: absolute;
        top: 50%;
        left: 0;
        // bottom: 0;
        margin-top: -18px;
        // margin: auto;
      }
    }
    .status {
      color: #e70000;
      font-size: 36px;
      line-height: 34px;
      vertical-align: -4px;
      // margin-top: 40px;
      position: relative;
      top: 7px;
      &.success {
        color: #00c35b;
      }
    }
  }
  .list-item-main {
    margin-top: 50px;
    display: flex;
    .product-icon {
      width: 140px;
      height: 140px;
      display: inline-block;
      margin-left: 14px;
      margin-right: 56px;
    }
    .product-info {
      flex: 1;
      & > div {
        display: flex;
        justify-content: space-between;
        align-items: center;
        &.first-line {
          padding-top: 5px;
        }
        &.right {
          justify-content: flex-end;
          margin-top: 72px; 
        }
      }
      .product-title {
        line-height: 34px;
        font-size: 36px;
        vertical-align: -4px;
        // margin-top: 5px;
      }
      .product-price {
        font-size: 36px;
        line-height: 34px;
        vertical-align: -4px;
      }
      .product-value {
        line-height: 30px;
        font-size: 30px;
        color: #999;
        margin-top: 25px; 
      }
      .total-price {
        font-size: 36px;
        line-height: 30px;
        vertical-align: -12px;
        // margin-top: 72px;
      }
    }
  }
  .list-item-bottom {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    margin: auto;
    width: 987px;
    height: 135px;
    display: flex;
    border-top: 1Px solid #f0f0f0;
    justify-content: flex-end;
    align-items: center;
    padding-left: 8px;
    button {
      width: 210px;
      height: 72px;
      border-radius: 40px;
      margin-left: 20px;
      border: 1Px solid #aaaaaa;
      color: #aaaaaa;
      background-color: #fff;
      font-size: 36px;
      &.active {
        border-color: #077af9;
        background-color: #077af9;
        color: #fff;

      }
    }
  } 
  // .RLI-left {
  //   flex: 0 0 78%;
  //   .RLI-left-date {
  //     margin-top: 40px;
  //     font-size: 30px;
  //     line-height: 30px;
  //     color: #666;
  //     text-indent: 53px;
  //     position: relative;
  //     &::before {
  //       content: '';
  //       width: 36px;
  //       height: 33px;
  //       background: url('../assets/img/record-date-icon.png') 0 0 / 100% 100% no-repeat;
  //       position: absolute;
  //       top: 0;
  //       left: 0;
  //       bottom: 0;
  //       margin: auto;
  //     }
  //   }
  //   .RLI-left-product {
  //     display: flex;
  //     margin-top: 50px;
  //     .product-icon {
  //       width: 140px;
  //       height: 140px;
  //       display: inline-block;
  //       margin-left: 14px;
  //       margin-right: 56px;
  //     }
  //     .product-title {
  //       line-height: 34px;
  //       font-size: 36px;
  //       margin-top: 5px;
  //     }
  //     .product-value {
  //       line-height: 30px;
  //       font-size: 30px;
  //       color: #999;
  //       margin-top: 25px;
  //     }
  //   }
  // }
  // .RLI-right {
  //   text-align: right;
  //   position: relative;
  //   .RLI-right-status {
  //     color: #e70000;
  //     font-size: 36px;
  //     line-height: 34px;
  //     vertical-align: -4px;
  //     margin-top: 40px;
  //     &.success {
  //       color: #00c35b;
  //     }
  //   }
  //   .RLI-right-price {
  //     font-size: 36px;
  //     line-height: 30px;
  //     vertical-align: -6px;
  //     margin-top: 51px;
  //   }
  //   .RLI-right-num {
  //     font-size: 30px;
  //     line-height: 25px;
  //     color: #999;
  //     margin-top: 29px;
  //   }
  //   .RLI-right-total {
  //     font-size: 36px;
  //     line-height: 36px;
  //     position: absolute;
  //     bottom: 162px;
  //     right: 0;
  //     white-space: nowrap;
      
  //   }
  // }
  // .RLI-bottom {
  //   position: absolute;
  //   left: 0;
  //   right: 0;
  //   bottom: 0;
  //   margin: auto;
  //   width: 987px;
  //   height: 135px;
  //   display: flex;
  //   border-top: 1Px solid #f0f0f0;
  //   justify-content: flex-end;
  //   align-items: center;
  //   padding-left: 8px;
  //   button {
  //     width: 210px;
  //     height: 72px;
  //     border-radius: 40px;
  //     margin-left: 20px;
  //     border: 1Px solid #aaaaaa;
  //     color: #aaaaaa;
  //     background-color: #fff;
  //     font-size: 36px;
  //     &.active {
  //       border-color: #077af9;
  //       background-color: #077af9;
  //       color: #fff;

  //     }
  //   }
  // } 
}
.no-record {
  font-size: 45px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  // margin-top: 20%;
  margin-top: 265px;
  .no-record-icon {
    width: 210px;
    height: auto;
    margin-bottom: 52px;
  } 
}
</style>